import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate, Link } from "react-router-dom";

import AuthLayout from "../AuthLayout";
import { AuthError } from "../../utils/errors";
import { confirmSignUp } from "../../api/auth";
import { useAuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

function ConfirmEmailPage() {
  const { t } = useTranslation("auth");
  const { lastUserId } = useAuthContext();
  const navigate = useNavigate();

  const [confirmationCode, setConfirmationCode] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      await confirmSignUp(lastUserId, confirmationCode);
      navigate("/sign_in");
    } catch (error) {
      if (error instanceof AuthError) {
        setErrorMessage(error.details);
      }
      console.error(error.message);
    }
  }

  const body = (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="confirmation_code" className="mb-3">
        <Form.Label>{t("confirmationCode")}</Form.Label>
        <Form.Control
          type="text"
          autoFocus={true}
          autoComplete="one-time-code"
          value={confirmationCode}
          onChange={(e) => {
            setConfirmationCode(e.target.value);
          }}
          required
          isInvalid={!!errorMessage}
        />
        <Form.Control.Feedback type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>
      <Button variant="primary" type="submit" className="w-100">
        {t("confirmEmailAddress")}
      </Button>
    </Form>
  );

  const links = (
    <React.Fragment>
      <Link to="/sign_in">{t("signIn")}</Link>
      <Link to="/sign_up/resend_confirmation_email">
        {t("resendConfirmationEmailLink")}
      </Link>
    </React.Fragment>
  );

  return <AuthLayout title="Confirm email" body={body} footer={links} />;
}

export default ConfirmEmailPage;
